import React, { useEffect, useState } from "react";
import {
    Box
} from "@mui/material";
import UserDanceTable from "./UserDanceTable";
import BlurredComponent from "../common/BlurredComponent_all";
import { useWebSocket } from "../net/WebSocketContext";
const UsersList = () => {
    const { ws, isConnected, ws_data, progress, loading} = useWebSocket();
    const [events, setEvents] = useState([]);
    const [users, setUsers] = useState([]);
    const [filters, setFilters] = useState(() => {
        return (
            JSON.parse(localStorage.getItem("user_filters")) ||
            {
                name: "",
                event: "",
                event_v: "",
                dance: "",
                category: "",
                role: "",
                class: "",
                number :""
            })
    });
    useEffect(() => {
        localStorage.setItem("user_filters", JSON.stringify(filters));
    }, [filters]);


    useEffect(() => { // Пишем в WS
        if (!ws) {
            console.log("Нет готовности отправлять по ws")
            return;}
        const sendOnOpen = () => {
            //setWait(true)
            const { event, ...filtersWithoutEvent } = filters;
            const message = {
                action: "users_list",
                'event':filters?.event?.event?.value,
                ...filtersWithoutEvent
            }
            ws.zsend(JSON.stringify(message));
            console.log("SEND:",message);
        };
        if (ws.readyState === WebSocket.OPEN) {
            sendOnOpen();
        } else {
            ws.addEventListener("open", sendOnOpen);
        }
        return () => {
            ws.removeEventListener("open", sendOnOpen);
        };
    }, [ws,filters]);
    useEffect(() => { // Читаем WS
        if (isConnected && ws_data) {
            //const data = JSON.parse(ws_event.data);
            console.log("ON_MESSAGE User_List",ws_data, filters )
            if (ws_data.type === "refresh") {
                const { event, ...filtersWithoutEvent } = filters;
                const message = {
                    action: "users_list",
                    'event':filters?.event?.event?.value,
                    ...filtersWithoutEvent

                }
                ws.zsend(JSON.stringify(message));
                console.log("SEND:",message);
            }
            //console.log(ws_data?.users_list)
            if (ws_data?.users_list) {
                setUsers(ws_data.users_list);
            }
            if (ws_data.events) {
                setEvents(ws_data.events);
            }
            //setWait(false)
        }
    },[ws_data]);


    return (
        <>
            <BlurredComponent isBlurred={(!isConnected || loading)} message={progress + "%"}>
            </BlurredComponent>
        <Box  sx={{
            width: '100%',
            margin: "auto",
            mt: 0,
            p: 1,
            //height: (window.innerHeight - 50) + 'px'
        }}>
            <UserDanceTable
                users={users} events={events} filters={filters} setFilters={setFilters} ></UserDanceTable>

        </Box>
        </>
    );
};

export default UsersList;
